export const LicenceTypeFactory = () => {
    return function LicenceType() {

        this.id = null;
        this.code = null;
        this.name = null;
    };
};
